import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { useRouter } from 'next/router'
import ReactSVG from 'react-svg'
import useTranslation from 'next-translate/useTranslation'
import { connect } from 'react-redux'
import { BreadCrumbs } from '../BreadCrumbs'

import { getVehiclePart } from '../../selectors'

import translations from '../../../../../../public/data/translations.json'

const ProductHeader = ({ vehiclePart }) => {
	const { t, lang } = useTranslation('common')

	const locale = lang?.toUpperCase() || 'ME'

	const router = useRouter()

	const imgMain = Array.isArray(vehiclePart?.img_path) ?
		vehiclePart?.img_path.map((image, index) => ({ id: index + 1, src: `https://slikeprodavnica.autodiler.me/original${image.img}` }))[0]?.src
		: null

	return (
		<>
			<div className='vehicle-part-header'>
				<button className='vehicle-part-header-back' onClick={() => router.back()}>
					<ReactSVG src='/icons/091.nazad.svg' wrapper='span' className='vehicle-part-header-back__icon' beforeInjection={svg => {
						svg.setAttribute('width', '35px')
						svg.setAttribute('height', '35px')
					}} />
				</button>

				<div className='vehicle-part-header-title-breadcrumbs'>
					<h1 className='vehicle-part-header-title-breadcrumbs__title'>{vehiclePart.name?.name}</h1>
					<BreadCrumbs />
				</div>

				<button className='vehicle-part-header-share'
					onClick={() => {
						if (navigator.share) {
							navigator.share({
								title: vehiclePart.name?.name || 'NOVI DJELOVI - AUTO DILER',
								url: `https://autodiler.link/shop/${lang !== 'me' ? `${lang}/` : ''}${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}/${translations.proizvod[locale]}/${vehiclePart.name?.slug}`
							})
						}
					}}
				>
					<ReactSVG src='/icons/share.svg' wrapper='span' beforeInjection={svg => {
						svg.setAttribute('width', '30px')
						svg.setAttribute('height', '30px')

						svg.querySelectorAll('path').forEach(path => {
							path.setAttribute('fill', '#0377cd')
						})
					}} />
				</button>
			</div>

			<div className='vehicle-part-header vehicle-part-header-mobile'>
				<div className='vehicle-part-header-mobile__top'>
					<a href='javascript:void(0)' onClick={() => router.back()}>
						<ReactSVG src='/icons/back.svg' wrapper='span' beforeInjection={svg => {
							svg.setAttribute('width', '30px')
							svg.setAttribute('height', '30px')
							svg.querySelectorAll('path').forEach(path => {
								path.setAttribute('fill', '#ddd')
							})
						}} />
					</a>

					<a
						href='javascript:void(0)' onClick={() => {
							if (navigator.share) {
								navigator.share({
									title: vehiclePart?.name?.name || 'NOVI DJELOVI - AUTO DILER',
									url: `https://autodiler.link/shop/${lang !== 'me' ? `${lang}/` : ''}${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}/${translations.proizvod[locale]}/${vehiclePart?.name?.slug}`
								})
							}
						}}
						style={{
							float: 'right'
						}}
					>
						<ReactSVG src='/icons/share.svg' wrapper='span' beforeInjection={svg => {
							svg.setAttribute('width', '25px')
							svg.setAttribute('height', '25px')
							svg.querySelectorAll('path').forEach(path => {
								path.setAttribute('fill', '#ddd')
							})
						}} />
					</a>

					<div className='vehicle-part-header-mobile__top-info'>
						<div className='vehicle-part-header-mobile__top-ad-img'>
							{imgMain ? <img width={52} src={imgMain} alt={vehiclePart?.name?.name} /> : null}
						</div>

						<div className='vehicle-part-header-mobile__top-ad-info'>
							<p>{vehiclePart?.name?.name}</p>

							<div className='vehicle-part-header-mobile__top-ad-info-price'>
								<p className='vehicle-part-header-info__price--new'>
									{vehiclePart?.discounted_price > 0 && vehiclePart?.show_discount && vehiclePart?.price
										? `${Number(vehiclePart?.discounted_price).toFixed(2)}€`
										: `${Number(vehiclePart?.price).toFixed(2)}€`
									}
								</p>
								<p className='vehicle-part-header-info__price--old'>
									{vehiclePart?.discounted_price > 0 && vehiclePart?.show_discount ? `${Number(vehiclePart?.price).toFixed(2)}€` : null}
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

ProductHeader.propTypes = {
	vehiclePart: PropTypes.object.isRequired,
}

ProductHeader.displayName = 'VehiclePartHeader'

const mapStateToProps = state => {
	return {
		vehiclePart: getVehiclePart(state) || {},
	}
}

export default connect(mapStateToProps)(ProductHeader)

